import React from 'react';
import { SEO } from '../components/SEO';
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const RepararServidorCarpeta = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Reparar Servidor de Carpeta OPUS | Soporte ECO SOFT"
        description="Procedimiento paso a paso para reparar el servidor SQL Server de OPUS cuando se presentan errores en el modo carpeta"
        name="RepararServidorCarpeta"
        type="article"
      />
      
      {/* Hero Section */}
      <section className="relative h-[450px] bg-gradient-to-r from-[#003171] to-[#0066CC]">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-3xl text-white">
            <h1 className="text-5xl font-bold mb-4">Reparar Servidor de Carpeta OPUS</h1>
            <p className="text-xl mb-8">
              Procedimiento para resolver problemas con el servidor SQL Server de OPUS en modo carpeta
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          
          {/* Descripción del Problema */}
          <section className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-[#003171]">Descripción del Problema</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-8 rounded">
              <p className="text-lg text-gray-700">
                En ocasiones, el servidor de SQL Server que administra las obras en modo carpeta de OPUS se daña. No se conocen con precisión cuáles son las razones para dañarse, pero OPUS cuenta con un procedimiento para repararlo.
              </p>
            </div>
          </section>

          {/* Identificación del Error */}
          <section className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-[#003171]">Identificación del Error</h2>
            <p className="text-lg text-gray-700 mb-6">
              Si al ingresar a la aplicación de OPUS se despliega un error semejante al siguiente y con un texto similar:
            </p>
            <div className="text-center mb-6">
              <img 
                src="/images/SOPO/image4.png" 
                alt="Mensaje de error que aparece cuando el servidor de carpeta de OPUS está dañado" 
                className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
              />
              <p className="mt-3 text-sm text-gray-600 italic">
                Ejemplo de error cuando el servidor de carpeta está dañado
              </p>
            </div>
          </section>

          {/* Procedimiento de Reparación */}
          <section className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-[#003171]">Procedimiento de Reparación</h2>
            <p className="text-lg text-gray-700 mb-8">
              <strong>Ejecute los siguientes pasos para reparar el servidor de SQL Server:</strong>
            </p>
            
            <div className="space-y-8">
              {/* Paso 1 */}
              <div className="bg-gray-50 border-l-4 border-green-600 p-6 rounded-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                      1
                    </div>
                  </div>
                  <div className="ml-4 w-full">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">
                      Presione el botón de Inicio de Windows.
                    </h3>
                    <div className="mt-4 text-center">
                      <img 
                        src="/images/SOPO/image3.png" 
                        alt="Botón de Inicio de Windows" 
                        className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
                      />
                      <p className="mt-3 text-sm text-gray-600 italic">
                        Botón de Inicio de Windows
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Paso 2 */}
              <div className="bg-gray-50 border-l-4 border-green-600 p-6 rounded-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                      2
                    </div>
                  </div>
                  <div className="ml-4 w-full">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">
                      Presione el botón "Todos" desplegado en el selector de aplicaciones.
                    </h3>
                    <div className="mt-4 text-center">
                      <img 
                        src="/images/SOPO/image_2.png" 
                        alt="Botón Todos en el selector de aplicaciones de Windows" 
                        className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
                      />
                      <p className="mt-3 text-sm text-gray-600 italic">
                        Ubicación del botón "Todos" en el selector de aplicaciones
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Paso 3 */}
              <div className="bg-gray-50 border-l-4 border-green-600 p-6 rounded-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold text-sm">
                      3
                    </div>
                  </div>
                  <div className="ml-4 w-full">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">
                      Busque la carpeta "Ecosoft OPUS 2025", de click sobre "Reparar servidor de carpeta" para ejecutarla.
                    </h3>
                    <div className="mt-4 text-center">
                      <img 
                        src="/images/SOPO/image1.png" 
                        alt="Carpeta Ecosoft OPUS 2025 con la opción Reparar servidor de carpeta" 
                        className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
                      />
                      <p className="mt-3 text-sm text-gray-600 italic">
                        Opción "Reparar servidor de carpeta" en la carpeta Ecosoft OPUS 2025
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Posibles Escenarios */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-8 text-[#003171]">Posibles Escenarios</h2>
            
            {/* Escenario 1: Reinicio Requerido */}
            <div className="mb-8">
              <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-lg mb-6">
                <h3 className="text-lg font-semibold text-orange-700 mb-3">Escenario 1: Reinicio Requerido</h3>
                <p className="text-gray-700 mb-4">
                  Dependiendo de las condiciones por las que no funciona correctamente el servidor de carpeta, es posible que se muestre un mensaje como el siguiente, pidiendo que <strong>REINICIE SU EQUIPO PARA QUE LOS CAMBIOS TENGAN EFECTO:</strong>
                </p>
                <div className="text-center mb-4">
                  <img 
                    src="/images/SOPO/image.png" 
                    alt="Mensaje solicitando reiniciar el equipo para completar la reparación" 
                    className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
                  />
                  <p className="mt-3 text-sm text-gray-600 italic">
                    Mensaje solicitando reinicio del equipo
                  </p>
                </div>
                <p className="text-gray-700">
                  En tal caso, reinicie manualmente su equipo y, al reiniciarse, se completará el proceso de reparación de su servidor de carpeta.
                </p>
              </div>
              
              <div className="text-center mb-6">
                <img 
                  src="/images/SOPO/image2.png" 
                  alt="Proceso completado después del reinicio" 
                  className="max-w-full h-auto rounded-lg shadow-md border border-gray-300 mx-auto"
                />
                <p className="mt-3 text-sm text-gray-600 italic">
                  Confirmación del proceso completado tras el reinicio
                </p>
              </div>
            </div>

            {/* Escenario 2: Sin Reinicio */}
            <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-green-700 mb-3">Escenario 2: Sin Reinicio Necesario</h3>
              <p className="text-gray-700 mb-2">
                En caso de que no fuera necesario reiniciar el equipo, se mostrará el mismo mensaje y deberá ejecutar OPUS para verificar que el servidor ya se encuentra reparado.
              </p>
              <p className="text-gray-700">
                <strong>Si aún no funciona, comuníquese con su distribuidor.</strong>
              </p>
            </div>
          </section>

          {/* Información de Contacto */}
          <section className="mb-12">
            <div className="bg-[#0066CC]/10 border border-[#0066CC]/20 rounded-lg p-8 text-center">
              <h3 className="text-xl font-semibold text-[#003171] mb-4">¿Necesita ayuda adicional?</h3>
              <p className="text-gray-700 mb-6">
                Si el problema persiste después de seguir estos pasos, no dude en contactar a su distribuidor autorizado de OPUS para obtener asistencia técnica especializada.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a 
                  href="https://wa.me/525539908312" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-[#25D366] text-white font-semibold rounded-lg hover:bg-[#20BD5C] transition-colors flex items-center"
                >
                  <FaWhatsapp className="mr-2" /> Contactar Soporte
                </a>
                <Link 
                  to="/soporte/descargas" 
                  className="px-6 py-3 border-2 border-[#0066CC] text-[#0066CC] hover:bg-[#0066CC] hover:text-white font-semibold rounded-lg transition-colors"
                >
                  Centro de Descargas
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* CTA Section similar a FAQ */}
      <section className="py-16 bg-[#1A2B39] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">¿Necesita más información?</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Explore nuestras otras opciones de soporte técnico y recursos disponibles.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/soporte/faq" 
              className="px-8 py-3 bg-[#0066CC] hover:bg-[#0088FF] text-white font-medium rounded-md transition-colors"
            >
              Preguntas Frecuentes
            </Link>
            <Link 
              to="/contacto" 
              className="px-8 py-3 border border-white hover:bg-white hover:text-[#1A2B39] text-white font-medium rounded-md transition-colors"
            >
              Solicitar Soporte
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RepararServidorCarpeta;
